// extracted by mini-css-extract-plugin
export default {"main":"RankingItem_main__TiXT0","name":"RankingItem_name__8RYAx"};